import deviceKitName from "../../devices/deviceKitName";
import mercuryDevices from "./mercuryDevices";
import { strCode } from "../../localizations/strCode";

const deviceOptions = [
  ...Object.values(deviceKitName).map((device) => {
    return { id: device, value: device };
  }),
  ...Object.values(mercuryDevices).map((device) => {
    return { id: device, value: device };
  })
];

const unknownDeviceOption = {
  id: "Unknown",
  value: undefined
};

const deviceFilterOptions = [
  { id: 0, value: strCode.ALL_DEVICES_LABEL },
  ...deviceOptions,
  unknownDeviceOption
];

export { deviceOptions, deviceFilterOptions };
